
<figure class="video-figure">
  <video #video preload="auto" style="pointer-events: none;">
    <source [src]="src" type="video/mp4">
  </video>
  <div class="video-controls">
    <div>{{ currentTime }} / {{ totalTime }}</div>
  </div>
  <div class="video-controls">
    <button #skipBack type="button" class="btn btn-primary video-button">
      <i class="icon icon-skip_back_button"></i>
    </button>
    <button #playPause type="button" class="btn btn-primary video-button">
      <i *ngIf="isPaused" class="icon icon-play_button"></i>
      <i *ngIf="!isPaused" class="icon icon-pause_button"></i>
    </button>
  </div>
</figure>
